// @flow

import React from "react";
import { withRouter } from "react-router-dom";

import {
  FlashMessageConsumer,
  SummarySection,
  Card,
  ContactPerson,
  NewInquiryPage
} from "buba-components";
import DataFetcher from "buba-components/src/components/DataFetcher";
import { denormalizeJsonApi } from "buba-components/src/utils/denormalizeJsonApi";
import { Workflow } from "buba-components-ts";
import paths from "../../data/paths";
import { customerInquiryTabs, bankInquiryTabsNew } from "../../data/navLinks";
import { getInquiryV2, getDashboardActionsV2 } from "../../api/v2actions";
import styles from "./BankInquiryDashboard.scss";
import generateWorkFlowItems from "./workflowitems";

type BankInquiryDashboardProps = {
  match: {
    params: {
      id: string
    }
  }
};

const dashboardType = "bank_advisor";

const BankInquiryDashboardNew = ({
  match: {
    params: { id }
  }
}: BankInquiryDashboardProps) => {
  const confirmAction = (actionId, payload) => {
    switch (actionId) {
      case "action_id":
        return payload;
      default:
        return () => null;
    }
  };

  return (
    <FlashMessageConsumer>
      {({ addMessage }) => (
        <DataFetcher
          initialPayload={{
            id
          }}
          mapper={denormalizeJsonApi}
          onError={msg => addMessage(msg, "failure")}
          apiAction={getInquiryV2}
          redirectOnError
        >
          {({ data, isLoading }) => {
            const federalState = data && data.financingRequest.details.federalState;
            const companyName = data ? data.company.name : "";
            const amount = data ? data.financingRequest.projectAmount : "";
            const isBankAdvisorType = dashboardType === "bank_advisor";
            const createdAt = data ? data.createdAt : null;
            const status = data ? data.processingStatus : "";
            const assignedAgent = data ? data.guaranteeAgent : null;

            if (!data) return null;

            return (
              <NewInquiryPage
                backPath={isBankAdvisorType ? paths.bankInquiriesList : paths.customerInquiriesList}
                tabs={
                  isBankAdvisorType
                    ? inquiryId => bankInquiryTabsNew(inquiryId, data)
                    : customerInquiryTabs
                }
                isLoadingData={isLoading}
                issuedOn={createdAt && new Date(createdAt)}
                site="bank"
              >
                <>
                  <SummarySection
                    createdAtDate={data.createdAt}
                    level=""
                    status={status}
                    title={companyName}
                    volume={amount}
                    id={data.id}
                    key=""
                  />
                  <div className={styles.workflowContactCardContainer}>
                    <Card additionalCardStyles={styles.workflow}>
                      <h3 className={styles.workflowTitle}>Nächste Schritte zu Ihrem Vorhaben</h3>
                      <DataFetcher
                        apiAction={getDashboardActionsV2}
                        initialPayload={{ id }}
                        mapper={dashboardActionsResponse =>
                          generateWorkFlowItems(
                            id,
                            dashboardActionsResponse.data.data,
                            assignedAgent,
                            data
                          )
                        }
                        redirectOnError
                      >
                        {({ data: dashboardActions }) => {
                          return (
                            <Workflow
                              id={id}
                              items={dashboardActions}
                              confirmAction={confirmAction}
                              addMessage={addMessage}
                              isCurrentUserAssignedToInquiry
                            />
                          );
                        }}
                      </DataFetcher>
                    </Card>
                    <ContactPerson
                      title="Ihr Ansprechpartner"
                      contactPersonType="guaranteeBank"
                      bank={federalState}
                      contactPerson={`${assignedAgent?.firstName || "-"} ${assignedAgent?.lastName || ""}`}
                      phone={assignedAgent?.phoneNumber || "-"}
                      additionalCardStyles={styles.contactPerson}
                      email={assignedAgent?.email || "-"}
                    />
                  </div>
                </>
              </NewInquiryPage>
            );
          }}
        </DataFetcher>
      )}
    </FlashMessageConsumer>
  );
};

export default withRouter(BankInquiryDashboardNew);
